import React from "react";
import { ClickAwayListener } from "@mui/material";

import { IDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { ValidationIssue } from "../../rule-engine-core/Common/IDesignValidationProvider";

import { DataFormControl } from "./DataFormControl";
import { ObserveState } from "../../CommonUI/StateManagement/ObserveState";
import { StateManager } from "../../rule-engine-core/Common/StateManager";

import { UILayer } from "../../CommonUI/BuildlingBlocks/UILayer";
import { FileUploadLayer } from "../../CommonUI/BuilderUI/FileUploadLayer";
import { DataUtilities } from "../../rule-engine-core/Common/DataUtilities";
import { FileData } from "../../rule-engine-core/Common/FileData";

export abstract class FileFormControl extends DataFormControl {
    showFileName: boolean = true;
    showFileSize: boolean = true;
    showPreview: boolean = true;
    filesLimit: number = 3;
    private showLayer: boolean = false;

    openLayer = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        this.showLayer = true;
        StateManager.propertyChanged(this, "showLayer");
    };

    onClose = () => {
        this.showLayer = false;
        StateManager.propertyChanged(this, "showLayer");
    };

    renderLayerContent(): JSX.Element | null {
        const files = this.getFileObjects();
        return (
            <ObserveState
                listenTo={this}
                properties={["showLayer"]}
                control={() => (
                    <UILayer
                        open={this.showLayer}
                        showCloseButton
                        onClose={this.onClose}
                        renderUI={() => (
                            <ClickAwayListener
                                onClickAway={() => {
                                    this.showLayer = false;
                                    StateManager.propertyChanged(this, "showLayer");
                                }}
                            >
                                <div>
                                    <FileUploadLayer
                                        files={files}
                                        addFiles={this.addFiles}
                                        onDelete={this.deleteFile}
                                        showFileName={this.showFileName}
                                        showFileSize={this.showFileSize}
                                        showPreview={this.showPreview}
                                        filesLimit={this.filesLimit}
                                        onClose={this.onClose}
                                        title={"Upload Files:"}
                                    />
                                </div>
                            </ClickAwayListener>
                        )}
                    />
                )}
            />
        );
    }

    getDesignValidationIssues(): ValidationIssue[] {
        return [];
    }

    getRuntimeValidationIssues(): ValidationIssue[] {
        return [];
    }

    getAddedData(): IDataDefinition | IDataDefinition[] | undefined {
        return;
    }

    getStorageData(): object {
        let retData = super.getStorageData();

        retData = DataUtilities.addStorageData(
            this,
            retData,
            "showFileName",
            "showFileSize",
            "showPreview",
            "filesLimit",
            "showLayer",
        );

        return retData;
    }

    setStorageData(data: object): void {
        super.setStorageData(data);

        DataUtilities.setStorageData(
            this,
            data,
            "showFileName",
            "showFileSize",
            "showPreview",
            "filesLimit",
            "showLayer",
        );
    }

    protected addFiles = (files: FileData[]) => {
        if (this.valueName) {
            let oldfiles = this.getFileObjects();
            this.setFormDataValue(this.valueName, [...files, ...oldfiles]);
        }
    };

    protected deleteFile = (_file: FileData, index: number) => {
        if (this.valueName) {
            let oldfiles = this.getFileObjects();
            oldfiles.splice(index, 1);
            this.setFormDataValue(this.valueName, oldfiles);
        }
    };

    protected getFileObjects = (): FileData[] => {
        return this.valueName ? this.getFormDataValue(this.valueName) || [] : [];
    };
}
